import React, { useState, useEffect } from 'react';
import { FaExternalLinkAlt, FaYoutube } from 'react-icons/fa';
import LanguageIcon from '@mui/icons-material/Language';
import BookIcon from '@mui/icons-material/Book';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions, Select, MenuItem } from '@mui/material';
import Paper from '@mui/material/Paper';
import { Spotify } from 'react-spotify-embed';

import { supabase } from '../../../supabaseClient';

const LibraryList = ({ library, setLibrary, title }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);

  const handleLinkClick = (link) => {
    window.open(link, '_blank');
  };

  const getCategoryIcon = (category) => {
    if (category === 'youtube' || category === 'video') {
      return <FaYoutube />;
    } else if (category === 'article') {
      return <LanguageIcon />;
    } else if (category === 'book') {
      return <BookIcon />;
    } else {
      return null;
    }
  };

  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    setConfirmationOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      // Realiza la eliminación del elemento en la tabla 'library' utilizando Supabase
      const { data, error } = await supabase
        .from('library')
        .delete()
        .eq('id', selectedItem.id);
  
      if (error) {
        console.error('Error al eliminar el elemento:', error.message);
        return;
      }
  
      // Actualiza la lista de biblioteca eliminando el elemento eliminado
      const updatedLibrary = library.filter((item) => item.id !== selectedItem.id);
  
      // Actualiza el estado de la biblioteca y cierra el diálogo de confirmación
      setLibrary(updatedLibrary);
      setConfirmationOpen(false);
    } catch (error) {
      console.error('Error al eliminar el elemento:', error.message);
    }
  };

  const handleCancelDelete = () => {
    setSelectedItem(null);
    setConfirmationOpen(false);
  };

  const handleLanguageChange = async (itemId, newLanguage) => {
    try {
      const { data, error } = await supabase
        .from('library')
        .update({ language: newLanguage })
        .eq('id', itemId);

      if (error) {
        console.error('Error al actualizar el idioma:', error.message);
        return;
      }

      // Actualiza el estado local
      const updatedLibrary = library.map(item => 
        item.id === itemId ? { ...item, language: newLanguage } : item
      );
      setLibrary(updatedLibrary);
    } catch (error) {
      console.error('Error al actualizar el idioma:', error.message);
    }
  };

  return (
    <>
      <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
        <Typography variant="h5">{title}</Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Nombre</TableCell>
              <TableCell align="right">Enlace</TableCell>
              <TableCell align="right">Idioma</TableCell>
              <TableCell align="right">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {library.map((item) => (
              <TableRow key={item.id}>
                <TableCell>
                  {getCategoryIcon(item.type)} {item.title}
                  {item.type === 'podcast' && <Spotify link={item.url} wide={true} />}
                </TableCell>
                <TableCell align="right">
                  <Button onClick={() => handleLinkClick(item.url)}>
                    <FaExternalLinkAlt />
                  </Button>
                </TableCell>
                <TableCell align="right">
                  <Select
                    value={item.language || ''}
                    onChange={(e) => handleLanguageChange(item.id, e.target.value)}
                    size="small"
                  >
                    <MenuItem value="en">EN</MenuItem>
                    <MenuItem value="es">ES</MenuItem>
                  </Select>
                </TableCell>
                <TableCell align="right">
                  <Button variant='contained' color='error' onClick={() => handleDeleteClick(item)}>Borrar</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      <Dialog open={confirmationOpen} onClose={handleCancelDelete}>
        <DialogTitle>Confirmar eliminación</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            ¿Estás seguro de que quieres eliminar "{selectedItem && selectedItem.title}" de la biblioteca?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete}>Cancelar</Button>
          <Button onClick={handleConfirmDelete} color="error" autoFocus>
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default LibraryList;